// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
// import { ButtonPresentationProps } from "@insite/mobius/Button"; // Starter Custom Code
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import AddToCartOptionsAndButton, {
    AddToCartOptionsAndButtonStyles,
} from "@store/Library/Components/Toolkit/AddToCartOptionsAndButton";
import { productCardProps } from "@store/Themes/common/props/productCard";
/* Starter Custom Code - End */

// Foundation --->
import {
    useIsHideSignInToSeePriceButton,
    useIsSignedInAndhasToBeSignedIn,
} from "@store/Framework/Store/Context/ContextHooks";
import SignInToSeePriceButton from "@store/Library/Components/Foundation/SignInToSeePriceButton";
import { actionsCardStyles } from "@store/Themes/common/props/product";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { ProductAvailabilityStyles } from "@store/Overrides/Components/ProductAvailability";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
// <--- Foundation

interface OwnProps {
    showPrice: boolean;
    showAddToList: boolean;
}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
    // Foundation
    settingsCollection: getSettingsCollection(state),
    configurationCompleted: state.pages.productDetails.configurationCompleted,
});

const mapDispatchToProps = {};

type Props = ReturnType<typeof mapStateToProps> &
    HasProductContext &
    ResolveThunks<typeof mapDispatchToProps> &
    OwnProps;

export interface ProductListActionsStyles {
    wrapper?: InjectableCss;
    addToCartWrapper?: InjectableCss; // Starter Custom Code
    addToCartButton?: ButtonPresentationProps;
    quantityOrdered?: TextFieldProps;
    unitOfMeasureSelect?: SelectPresentationProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    price?: ProductPriceStyles;
    addToListLink?: ProductAddToListLinkStyles;
    addToListWrapper?: InjectableCss;
    // Starter Custom Code
    priceWrapper?: InjectableCss;
    addToCartOptionsAndButton?: AddToCartOptionsAndButtonStyles;
    // Foundation
    rightColumn?: InjectableCss;
    leftColumn?: InjectableCss;
    availabilityStyles?: ProductAvailabilityStyles;
}

export const actionsStyles: ProductListActionsStyles = {
    // Foundation --->
    unitOfMeasureSelect: {
        cssOverrides: {
            formField: css`
                margin-top: ${pxToRem(20)};
            `,
        },
    },
    addToCartWrapper: {
        css: css`
            display: flex;
            align-items: flex-end;
            margin-top: ${pxToRem(10)};
        `,
    },
    addToCartButton: {
        css: css`
            ${({ theme }) => theme.button?.primary?.css}
            width: 100%;
        `,
    },
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-right: ${pxToRem(10)};
                width: 4.1rem;
                min-width: 4.1rem;
            `,
        },
    },
    addToListWrapper: {
        css: css`
            margin-top: ${pxToRem(20)};
            min-height: 2rem;
        `,
    },
    addToListLink: {},
    wrapper: actionsCardStyles.wrapper,
    price: actionsCardStyles.price,
    quantityBreakPricing: actionsCardStyles.quantityBreakPricing,
    rightColumn: actionsCardStyles.rightColumn,
    leftColumn: actionsCardStyles.leftColumn,
    // <--- Foundation
};

const styles = actionsStyles;

const ProductListActions: FC<Props> = ({
    productContext,
    productSettings,
    showPrice,
    showAddToList,
    // Foundation
    settingsCollection,
    configurationCompleted,
}) => {
    // Foundation --->
    const isSignedInAndhasToBeSignedIn = useIsSignedInAndhasToBeSignedIn();
    const isHideSigneInToSeePriceButton = useIsHideSignInToSeePriceButton();
    const { isVariantParent } = productContext.product;
    // <--- Foundation

    if (isHideSigneInToSeePriceButton && !isSignedInAndhasToBeSignedIn) {
        return null;
    }

    return (
        // Foundation --->
        <StyledWrapper {...styles.wrapper}>
            {isSignedInAndhasToBeSignedIn ? (
                <>
                    {!isVariantParent && (
                        <StyledWrapper {...styles.leftColumn}>
                            {settingsCollection.productSettings.showInventoryAvailability && (
                                <ProductContextAvailability
                                    isProductDetailsPage={false}
                                    configurationCompleted={configurationCompleted}
                                    extendedStyles={styles.availabilityStyles}
                                />
                            )}
                            {showPrice && (
                                <>
                                    <ProductPrice
                                        product={productContext}
                                        showLabel={false}
                                        showSavings={true}
                                        showSavingsAmount={productSettings.showSavingsAmount}
                                        showSavingsPercent={productSettings.showSavingsPercent}
                                        extendedStyles={styles.price}
                                    />
                                    <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} />
                                </>
                            )}
                        </StyledWrapper>
                    )}
                    <StyledWrapper {...styles.rightColumn}>
                        <ProductAddToCartButton
                            data-test-selector={`actionsAddToCart${productContext.product.id}`}
                            extendedStyles={styles.addToCartButton}
                        />
                        {showAddToList && (
                            <ProductAddToListLink
                                data-test-selector={`actionsAddToList${productContext.product.id}`}
                                extendedStyles={styles.addToListLink}
                            />
                        )}
                    </StyledWrapper>
                    {/* Foundation */}
                    <ProductUnitOfMeasureSelect extendedStyles={styles.unitOfMeasureSelect} />
                    {/* Foundation -- Quantity */}
                </>
            ) : (
                <SignInToSeePriceButton {...styles.addToCartButton} />
            )}
        </StyledWrapper>
        // <--- Foundation
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(ProductListActions));
